module.exports = __webpack_public_path__ + "static/email-1fd1630af7cdfeec8b6ca67ab6259825.png";